import { tripOrderSagaWatcher } from './containers/TripContainer/services/saga';
import { tripsTabSagaWatcher, unloadingTripsTabSagaWatcher } from './containers/TripsTabContainer/services/saga';

export const orderingModuleSaga = [tripsTabSagaWatcher, unloadingTripsTabSagaWatcher, tripOrderSagaWatcher];
